<template>
  <div class="preview-container">
    <div v-if="isLoading">Memuat informasi tes...</div>
    <div v-else-if="testData">
      <!-- Kita pisahkan judul tes dan petunjuknya -->
      <h1>{{ testData.name }}</h1>
      <div class="card-section">
        <h2>Petunjuk Pengerjaan</h2>
        <div class="description-content" v-html="testData.description"></div>
      </div>
      <p><strong>Durasi:</strong> {{ testData.duration_minutes }} menit</p>
      
      <hr />

      <!-- Di dalam <template> TestPreview.vue -->

      <div v-if="testData.example_question" class="example-section">
        <h2>Contoh Soal</h2>
        
        <!-- ====================================================== -->
        <!--                PERBAIKAN UTAMA DI SINI                 -->
        <!-- ====================================================== -->

        <!-- 1. Gunakan 'testData.example_question.image_url' -->
        <div v-if="testData.example_question.image_url" class="question-image-container">
          <!-- 2. Hapus v-if yang tidak perlu dari dalam img -->
          <img :src="`${backendUrl}${testData.example_question.image_url}`" alt="Gambar Contoh Soal">
        </div>
        
        <!-- ====================================================== -->

        <div class="question-text" v-html="testData.example_question.text"></div>
        
        <div 
          v-for="option in testData.example_question.options" 
          :key="option.id" 
          class="option"
          :class="{ 'selected': selectedExample === option.id }"
          @click="selectExample(option.id)"
        >
          <img v-if="option.image_url" 
              :src="`${backendUrl}${option.image_url}`"
              alt="Pilihan Jawaban" 
              class="option-image"
          >
          <span v-if="option.text">{{ option.text }}</span>
        </div>
        <p class="note"><em>(Contoh soal tidak akan dinilai)</em></p>
      </div>
      
      <button @click="startTest" class="start-button" :disabled="isStarting">
        {{ isStarting ? 'Memulai...' : 'Mulai Tes Sekarang' }}
      </button>
    </div>
    <div v-if="error" class="error-message">{{ error }}</div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import apiClient from '@/services/api.js';

const backendUrl = process.env.NODE_ENV === 'production' 
    ? window.location.origin 
    : 'http://148.230.97.203:8011'; // Ganti dengan IP atau localhost backend Anda
// ----------------------------

const route = useRoute();
const router = useRouter();
const isLoading = ref(true);
const isStarting = ref(false);
const testData = ref(null);
const error = ref('');
const selectedExample = ref(null); // <-- TAMBAHKAN INI

onMounted(async () => {
  const testId = route.params.id;
  try {
    const response = await apiClient.get(`/tests/${testId}/preview`);
    testData.value = response.data;
  } catch (err) {
    error.value = 'Gagal memuat informasi tes.';
    console.error(err);
  } finally {
    isLoading.value = false;
  }
});

const startTest = async () => {
  isStarting.value = true;
  const testId = route.params.id;
  try {
    const response = await apiClient.post(`/sessions/tests/${testId}/start`);
    
    const startTime = new Date(response.data.start_time + 'Z');
    const durationMinutes = response.data.duration_minutes;
    const endTime = new Date(startTime.getTime() + durationMinutes * 60000);
    
    localStorage.setItem('test_end_time', endTime.toISOString());
    
    // --- TAMBAHKAN PENYIMPANAN DATA PENTING INI ---
    localStorage.setItem('current_test_details', JSON.stringify(testData.value));
    // ------------------------------------------
    console.log("Mengarahkan ke TestTaker dengan ID:", testId);
    router.push({ name: 'TestTaker', params: { id: testId } });
  } catch (err) {
    error.value = 'Gagal memulai sesi tes. Silakan coba lagi.';
    console.error(err);
    isStarting.value = false;
  }
};

// TAMBAHKAN FUNGSI INI
const selectExample = (optionId) => {
  selectedExample.value = optionId;
};
</script>

<style scoped>
.preview-container { max-width: 800px; margin: 40px auto; padding: 20px; border: 1px solid #eee; border-radius: 8px; }
.description { font-style: italic; color: #555; }
.example-section { margin-top: 30px; padding: 20px; background-color: #f8f9fa; border-radius: 5px; }
.question-text { font-weight: bold; font-size: 1.1em; }
.option { padding: 10px; border: 1px solid #ddd; margin-bottom: 5px; border-radius: 4px; cursor: pointer; transition: background-color 0.2s; }
.option:hover { background-color: #f0f0f0; }
.option.selected { background-color: #d4edda; border-color: #c3e6cb; }
.note { margin-top: 15px; font-size: 0.9em; color: #777; }
.start-button { font-size: 1.2em; padding: 15px 30px; margin-top: 30px; cursor: pointer; }
.error-message { color: red; margin-top: 15px; }
.question-image-container {
  margin-bottom: 20px;
}
.question-image-container img {
  max-width: 100%;
  max-height: 400px;
  display: block;
  margin: 0 auto;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.description-content {
  line-height: 1.6;
  color: #333;
}
/* Style ini akan menargetkan elemen di dalam v-html */
.description-content :deep(p) {
  margin-bottom: 1em;
}
.description-content :deep(ol) {
  padding-left: 25px;
  margin-top: 1em;
  margin-bottom: 1em;
}
.description-content :deep(li) {
  margin-bottom: 0.5em;
}
.card-section {
    margin-top: 20px;
    margin-bottom: 20px;
}
.option-image {
  max-width: 100px;
  max-height: 100px;
  border: 1px solid #eee;
}
.option {
  /* ... */
  display: flex;
  flex-direction: column; /* Atau 'row' jika ingin berdampingan */
  align-items: center;
  gap: 10px;
}
</style>